import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { useMemo, useCallback, useState } from 'react';
import { useDispatch } from 'react-redux';
import { KEYWORD_SUGGESTS } from '../../../../define/consts/consultant_search';
import { propFunc } from '../../../../helpers/custom-prop-types';
import { useCallConsultantSearchCountApi, useConsultantSearchForm, } from '../../../../helpers/use/consultant_search/useConsultantSearchCount';
import { useBoolState, useUnmountRef } from '../../../../helpers/use/useHook';
import DocumentBodyState from '../../../../helpers/window/DocumentBodyState';
import KeyboardArrowDownIcon from '../../../Icon/Svg/KeyboardArrowDownIcon';
import SearchSimpleIcon from '../../../Icon/Svg/SearchSimpleIcon';
import SubmitButton from '../../../Ui/Button/SubmitButton';
import ConsultantSearchCountText from '../../../Ui/ConsultantSearch/ConsultantSearchCountText';
import ConsultantSearchSuggestPopper from '../../../Ui/ConsultantSearch/ConsultantSearchSuggestPopper';
import ConsultantSearchTitleRow from '../../../Ui/ConsultantSearch/ConsultantSearchTitleRow';
const SearchCardKeyword = (props) => {
    const { setIsFullScreenMode } = props;
    const { professional, seminar, solution } = DocumentBodyState.attributes;
    const dispatch = useDispatch();
    const unmountRef = useUnmountRef();
    const [prevKeyword, changePrevKeyword] = useState();
    const { boolState: isFocusKeyword, changeFalse: blurKeyword, changeTrue: focusKeyword, } = useBoolState();
    const { boolState: isFocusSearch, changeFalse: blurSearch, changeTrue: focusSearch, } = useBoolState();
    const { loadTotal } = useCallConsultantSearchCountApi(dispatch);
    const { changeCountData, changeKeyword, changeSearch, countData, keyword, keywordRef, onSearch, resetCountData, search, searchOptions, } = useConsultantSearchForm({
        callback: loadTotal,
        defaultProfessionalCount: professional.totalCount,
        defaultSeminarCount: seminar.totalCount,
        defaultSolutionCount: solution.totalCount,
        includesSeminar: true,
        unmountRef,
    });
    const total = useMemo(() => {
        const count = countData[search.id];
        return parseInt(count, 10);
    }, [search, countData]);
    const onFocusKeyword = useCallback(() => {
        setIsFullScreenMode(true);
        focusKeyword();
    }, [setIsFullScreenMode, focusKeyword]);
    const onBlurKeyword = useCallback((e) => {
        const { value } = e.currentTarget;
        blurKeyword();
        if (!value) {
            resetCountData();
            return;
        }
        if (value !== prevKeyword) {
            changeCountData({ keyword: value });
            changePrevKeyword(value);
        }
    }, [blurKeyword, changeCountData, prevKeyword, resetCountData]);
    const onChangeKeyword = useCallback((e) => {
        const { value } = e.currentTarget;
        changeKeyword(value);
    }, [changeKeyword]);
    const onClickSearchSuggest = useCallback((e) => {
        const { value } = e.currentTarget;
        const option = searchOptions.find((v) => v.value === value);
        changeSearch(option);
        blurSearch();
    }, [searchOptions, changeSearch, blurSearch]);
    const onClickKeywordSuggest = useCallback((e) => {
        const { value } = e.currentTarget;
        blurKeyword();
        setIsFullScreenMode(false);
        changeKeyword((prev) => {
            if (prev !== value) {
                changeCountData({ keyword: value });
                changeKeyword(value);
                changePrevKeyword(value);
            }
            return value;
        });
    }, [
        changeCountData,
        changeKeyword,
        changePrevKeyword,
        setIsFullScreenMode,
        blurKeyword,
    ]);
    const onClickCancel = useCallback(() => {
        setIsFullScreenMode(false);
        blurKeyword();
    }, [setIsFullScreenMode, blurKeyword]);
    const onSubmit = useCallback((e) => {
        e.preventDefault();
        if (!keyword) {
            onFocusKeyword();
            keywordRef.current.focus();
            return;
        }
        onSearch();
    }, [keyword, keywordRef, onFocusKeyword, onSearch]);
    return (_jsxs("div", Object.assign({ className: 'card_body_section card_body_section_keyword' }, { children: [_jsx(ConsultantSearchTitleRow, { includesSeminar: true }), _jsx("div", Object.assign({ className: 'card_body_section_keyword_body' }, { children: _jsx("div", Object.assign({ className: 'card_body_section_keyword_form_row' }, { children: _jsxs("form", Object.assign({ className: 'card_body_section_keyword_form', onSubmit: onSubmit }, { children: [_jsxs("div", Object.assign({ className: 'search_input_wrapper' }, { children: [_jsxs("div", Object.assign({ className: 'search_input_box' }, { children: [_jsx("input", { autoComplete: 'off', className: 'search_input_keyword input-form-text', name: 'keyword', onBlur: onBlurKeyword, onChange: onChangeKeyword, onFocus: onFocusKeyword, placeholder: '新規市場、市場調査、など', ref: keywordRef, type: 'search', value: keyword }), _jsx("i", Object.assign({ className: 'search_input_icon material-icons' }, { children: "search" })), _jsx("button", Object.assign({ className: 'card_body_section_keyword_cancel', onClick: onClickCancel, type: 'button' }, { children: "\u30AD\u30E3\u30F3\u30BB\u30EB" }))] })), _jsx(ConsultantSearchSuggestPopper, { isShow: isFocusKeyword, onClick: onClickKeywordSuggest, suggests: KEYWORD_SUGGESTS, timeout: 300, title: '人気の検索ワード' })] })), _jsxs("div", Object.assign({ className: 'search_type_wrapper' }, { children: [_jsx(ConsultantSearchSuggestPopper, { className: 'type', isShow: isFocusSearch, onClick: onClickSearchSuggest, suggests: searchOptions, timeout: 300 }), _jsxs("button", Object.assign({ className: 'search_type_button', onBlur: blurSearch, onClick: focusSearch, type: 'button' }, { children: [search.label, _jsx(KeyboardArrowDownIcon, {})] }))] })), _jsx(ConsultantSearchCountText, { total: total }), _jsx("div", Object.assign({ className: 'search_button_submit' }, { children: _jsx(SubmitButton, { className: 'button primary', isDisabled: false, isLoading: false, text: _jsxs("div", { children: [_jsx("div", Object.assign({ className: 'search_button_text' }, { children: "\u63A2\u3059" })), _jsx(SearchSimpleIcon, { className: 'search_button_icon white' })] }) }) }))] })) })) }))] })));
};
SearchCardKeyword.propTypes = {
    setIsFullScreenMode: propFunc().isRequired,
};
export default SearchCardKeyword;
